import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";

export type ownerAutoCompleteItem = I_GENERIC_ITEMS<{
    ownerData: {
      name: string;
      id: string | number;
      identification: string;
      isConflictive: boolean;
      requiredConflictEvaluation: boolean;
      formData?: any;
    };
  }>

interface argOwnerAutoCompleteItemAdapter {
  name: string;
  id: string | number;
  identification: string;
  isConflictive: boolean;
  requiredConflictEvaluation: boolean;
  formData?: any;
}

const ownerAutoCompleteItemAdapter: (
  arg: argOwnerAutoCompleteItemAdapter
) => ownerAutoCompleteItem = arg => {
  return {
    label: `${arg.name}`,
    value: arg.id,
    id: arg.id,
    name: arg.name,
    extraData: {
      ownerData: {
        name: arg.name,
        id: arg.id,
        identification: arg.identification,
        isConflictive: arg.isConflictive,
        requiredConflictEvaluation: arg.requiredConflictEvaluation,
        formData: arg?.formData || null
      }
    }
  };
};

export { ownerAutoCompleteItemAdapter };
